var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgWhatsapp = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#svg-3830549269__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#25D366",
  d: "m0 16 .565-1.67c.262-.774.528-1.547.78-2.325a.46.46 0 0 0-.03-.327A7.79 7.79 0 0 1 6.549.168c4.319-.912 8.608 1.997 9.338 6.332.712 4.222-2.137 8.242-6.357 8.973-1.752.304-3.42.056-5.004-.753a.48.48 0 0 0-.399-.026c-1.294.416-2.591.824-3.888 1.235-.068.022-.137.041-.239.071"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.299 5.996c.025-.538.223-.996.575-1.4.292-.334.676-.389 1.075-.364.102.006.236.137.285.244q.356.781.67 1.58a.4.4 0 0 1-.033.317 3.8 3.8 0 0 1-.436.587c-.15.163-.175.3-.056.494.633 1.03 1.5 1.777 2.628 2.22.163.065.287.038.395-.096.188-.23.386-.453.563-.693.116-.157.252-.213.422-.134.54.249 1.08.499 1.608.772.08.042.135.212.131.32-.026.796-.582 1.4-1.366 1.566-.44.092-.847.034-1.271-.078-1.846-.487-3.234-1.588-4.301-3.14-.356-.517-.702-1.036-.825-1.665-.034-.174-.044-.353-.065-.53Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-3830549269__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h15.996v16H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhatsapp);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };